import gql from 'graphql-tag';

export default gql`
     mutation ($organizationId: String!){
         selectOrganization(organizationId: $organizationId)
    }
`;
